export default [
    {
        "id": "brandsSlider-1",
        "plugin": "brand",
        "pluginId": 7,
        "name": "manufacturer-brand",
        "html": require('./brandsSliders/brandsSlider-1/html').default,
        "svgContent": require('./brandsSliders/brandsSlider-1/svgContent').default,
        "svgViewBox": "0 0 1440 200",
        "svgContentMobile": require('./brandsSliders/brandsSlider-1/svgContentMobile').default,
        "svgViewBoxMobile": "0 0 360 176",
        "js": require('./brandsSliders/brandsSlider-1/js').default,
        "minJs": require('./brandsSliders/brandsSlider-1/minJs').default,
    }
]